import { Action } from '@ngrx/store';

export class FixedInvestActions implements Action {

    public static getProducts: string = '[FixedInvest] get';
    public static getProductsError: string = '[FixedInvest] get_error';
    public static getProductsSuccess: string = '[FixedInvest] get_success';

    public static setSelectedProduct: string = '[FixedInvest] set_selected_product';

    public static getProduct: string = '[FixedInvest] get_product';
    public static getProductError: string = '[FixedInvest] get_produc_error';
    public static getProductSuccess: string = '[FixedInvest] get_product_success';

    public static getProductsIndexBydate: string = '[FixedInvest] getProductsIndexBydate';
    public static getProductsIndexBydateError: string = '[FixedInvest] getProductsIndexBydate_error';
    public static getProductsIndexBydateSuccess: string = '[FixedInvest] getProductsIndexBydatet_success';

    public static getAdvices: string = '[FixedInvest] get_advices';
    public static getAdvicesError: string = '[FixedInvest] get_advices_error';
    public static getAdvicesSuccess: string = '[FixedInvest] get_advices_success';

    public static getIssuer: string = '[FixedInvest] get_issuer';
    public static getIssuerError: string = '[FixedInvest] get_issuer_error';
    public static getIssuerSuccess: string = '[FixedInvest] get_issuer_success';

    //@deprecated [init] - remover ate 01/01/2024
    public static getMyInvestments: string = '[FixedInvest] get_my_investments';
    public static getMyInvestmentsError: string = '[FixedInvest] get_my_investments_error';
    public static getMyInvestmentsSuccess: string = '[FixedInvest] get_my_investments_success';
    //@deprecated [end] - remover ate 01/01/2024

    public static getPositions: string = '[FixedInvest] get_positions';
    public static getPositionsError: string = '[FixedInvest] get_positions_error';
    public static getPositionsSuccess: string = '[FixedInvest] get_positions_success';

    public static getPositionsSegregated: string = '[FixedInvest] get_positions_segregated';
    public static getPositionsSegregatedError: string = '[FixedInvest] get_positions_segregated_error';
    public static getPositionsSegregatedSuccess: string = '[FixedInvest] get_positions_segregated_success';

    public static updateSimulation: string = '[FixedInvest] update_simulation';
    public static computeSimulation: string = '[FixedInvest] compute_simulation';
    public static computeSimulationSuccess: string = '[FixedInvest] compute_simulation_success';

    public static buyProduct: string = '[FixedInvest] buy_product';
    public static buyProductError: string = '[FixedInvest] buy_product_error';
    public static buyProductSuccess: string = '[FixedInvest] buy_product_success';

    public static findAcceptedFgcOvertaken: string = '[FixedInvest][FGC] find_overtaken';
    public static findAcceptedFgcOvertakenError: string = '[FixedInvest][FGC] find_overtaken_error';
    public static findAcceptedFgcOvertakenSuccess: string = '[FixedInvest][FGC] find_overtaken_success';
    public static acceptFgcOvertaken: string = '[FixedInvest][FGC] accept_overtaken';
    public static setIssuersFgcOvertaken: string = '[FixedInvest][FGC] set_issuers_fgc_overtaken';

    public static testFileLogo: string = '[FixedInvest] test_file_logo';

    constructor(
        public type: string,
        public payload?: any,
        public values?: any,
    ) {}
}
